var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14268_13276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 10,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 4.66699C11.3996 4.66699 12.0002 5.26667 12.0002 6V12.667C12.0001 13.4002 11.3995 14 10.6663 14H5.33325C4.60003 14 4.00042 13.4002 4.00024 12.667V6C4.00024 5.26667 4.59992 4.66699 5.33325 4.66699H10.6663ZM6.00024 6C5.63358 6 5.33325 6.30033 5.33325 6.66699V12C5.33325 12.3667 5.63358 12.667 6.00024 12.667H10.0002C10.3668 12.6668 10.6663 12.3666 10.6663 12V6.66699C10.6663 6.30043 10.3668 6.00018 10.0002 6H6.00024ZM9.39282 2C9.56609 2 9.73962 2.07344 9.85962 2.19336L10.3333 2.66699H12.0002C12.3667 2.66717 12.6661 2.9666 12.6663 3.33301C12.6663 3.69957 12.3668 3.99982 12.0002 4H4.00024C3.63358 4 3.33325 3.69967 3.33325 3.33301C3.33343 2.96649 3.63369 2.66699 4.00024 2.66699H5.66626L6.13989 2.19336C6.25989 2.07336 6.43336 2 6.60669 2H9.39282Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14268_13276)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F46A6A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.34eca984.svg";
export { ForwardRef as ReactComponent };